import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileState } from './profile.state';

// Feature selector
export const selectProfileState = createFeatureSelector<ProfileState>('profile');

// Basic selectors
export const selectProfile = createSelector(selectProfileState, (state: ProfileState) => state.profile);

export const selectProfileLoading = createSelector(selectProfileState, (state: ProfileState) => state.loading);

export const selectProfileError = createSelector(selectProfileState, (state: ProfileState) => state.error);

// Derived selectors
export const selectIsProfileLoaded = createSelector(selectProfile, (profile) => profile !== null);

export const selectProfileFullName = createSelector(selectProfile, (profile) =>
  profile ? `${profile.firstName} ${profile.lastName}` : null
);

export const selectProfileRoles = createSelector(selectProfile, (profile) => profile?.roles || []);

export const selectProfileGroups = createSelector(selectProfile, (profile) => profile?.groups || []);

export const selectProfileEmail = createSelector(selectProfile, (profile) => profile?.email || null);
